export const APP_ENVIRONMENT = globalThis?.import_meta_env?.VUE_APP_ENVIRONMENT || process.env.VUE_APP_ENVIRONMENT || 'production'

export const APP_AUTH_URL = globalThis?.import_meta_env?.VUE_APP_AUTH_URL || process.env.VUE_APP_AUTH_URL || 'https://emcd.io/auth'

export const ENDPOINT_API_URL = globalThis?.import_meta_env?.VUE_APP_ENDPOINT_API_URL || process.env.VUE_APP_ENDPOINT_API_URL || 'https://endpoint.emcd.io'

export const APP_SUSPENDED_URL = globalThis?.import_meta_env?.VUE_APP_SUSPENDED_URL || process.env.VUE_APP_SUSPENDED_URL || 'https://emcd.io/auth/suspended'

export const APP_SUCCESS_REDIRECT_DEFAULT = globalThis?.import_meta_env?.VUE_APP_SUCCESS_REDIRECT_DEFAULT || process.env.VUE_APP_SUCCESS_REDIRECT_DEFAULT || 'https://emcd.io/wallets'

export const APP_ENVIRONMENT_COOKIE = `app_environment`

export const ACCESS_TOKEN_COOKIE = `auth_${
  APP_ENVIRONMENT === 'production' ? '' : APP_ENVIRONMENT
}_access_token`

export const REFRESH_TOKEN_COOKIE = `auth_${
  APP_ENVIRONMENT === 'production' ? '' : APP_ENVIRONMENT
}_refresh_token`

export const REDIRECT_URL_COOKIE = `auth_${
  APP_ENVIRONMENT === 'production' ? '' : APP_ENVIRONMENT
}_redirect_url`

export const FINGERPRINT_COOKIE = `auth_${
  APP_ENVIRONMENT === 'production' ? '' : APP_ENVIRONMENT
}_fingerprint`

export const ACCOUNT_ID_COOKIE = `auth_${
  APP_ENVIRONMENT === 'production' ? '' : APP_ENVIRONMENT
}_accountID`

export const USER_ID_COOKIE = `auth_${
  APP_ENVIRONMENT === 'production' ? '' : APP_ENVIRONMENT
}_userID`

export const USERNAME_COOKIE = `auth_${
  APP_ENVIRONMENT === 'production' ? '' : APP_ENVIRONMENT
}_username`

export const PREFFERED_COIN_COOKIE = 'coin'

export const ACCESS_TOKEN_DEFAULT_EXPIRE_TIME = 7

export const REFRESH_TOKEN_DEFAULT_EXPIRE_TIME = 7

export const REDIRECT_URL_DEFAULT_EXPIRE_TIME = 7

export const ACCOUNT_ID_DEFAULT_EXPIRE_TIME = 7

export const USER_ID_DEFAULT_EXPIRE_TIME = 7

export const USERNAME_DEFAULT_EXPIRE_TIME = 7

export const PREFFERED_COIN_DEFAULT_EXPIRE_TIME = 7

export const API_AUTH_HEADER = 'X-Access-Token'

export const API_AUTH_TOKEN_PREFIX = ''

export const STREAM_TOKEN = `stream_${
    APP_ENVIRONMENT === 'production' ?'' : APP_ENVIRONMENT
}_TOKEN`;

export const WILDCARDS_DOMAIN = globalThis?.import_meta_env?.VUE_APP_WILDCARDS_DOMAIN || process.env.WILDCARDS_DOMAIN || /(.*\.)?(emcd\.io|localhost|emcdpool(\.com)?|mytstnv\.site|dev-b2b\.site|performa\.com).*/gm

export const HTTP_STATUS_CODES = {
  OK: 200,
  CREATED: 201,
  NO_CONTENT: 204,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  METHOD_NOT_ALLOWED: 405,
  PROXY_AUTHENTICATION_REQUIRED: 407,
  REQUEST_TIMEOUT: 408,
  CONFLICT: 409,
  UNPROCESSABLE_ENTITY: 422,
  LOCKED: 423,
  TOO_MANY_REQUESTS: 429,
  REQUIRED_USER_ACTION: 444,
  INTERNAL_SERVER_ERROR: 500,
  NOT_IMPLEMENTED: 501,
  SERVICE_UNAVAILABLE: 503,
  GATEWAY_TIMEOUT: 504,
}

export const REQUIRED_USER_ACTIONS = {
  TWO_FA_SETUP: '2fa-setup',
  TWO_FA_GOOGLE: '2fa-google',
  TWO_FA_SMS: '2fa-sms',
  REGISTRATION: 'registration',
  SUSPENDED: 'suspended',
  PASSKEY: "2fa-passkey",
};

export const TYPES_2FA_OTP = {
  SMS: 'SMS',
  CALL: 'F_CALL',
  PUSH: 'PUSH',
  GOOGLE: 'google',
  UNKNOWN: '',
  GENERAL: 'GENERAL',
};

export const TWO_FA_TYPES_MAPPER = {
  [REQUIRED_USER_ACTIONS.TWO_FA_GOOGLE]: TYPES_2FA_OTP.GOOGLE,
  [REQUIRED_USER_ACTIONS.TWO_FA_SMS]: TYPES_2FA_OTP.SMS,
}

export const CAPTCHA_CHALLENGES = ['v3-hide','emcd-puzzle']

export const TWO_FA_CONTEXT_FLOW = {
  REGISTRATION: 'registration',
  AUTH: 'auth',
  DEFAULT: 'default'
}
